import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import { kioskstyles } from "./../../kioskstyles";
import KioskStylesReact from "./../../KioskStylesReact";
import {
  loginViaSocket,
  reloginViaSocket
} from "./HelperFunctions/socketFuntions";
import { displayLoginError } from "./HelperFunctions/ErrorDisplayFunctions";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import CircleButton from "./Components/Buttons/CircleButton";
import Logo from "./Components/Logo";
import LanguageButtons from "./Components/Shared/LanguageButtons";
import SubtitleWrapper from "./Components/Shared/PanelElements/SubtitleWrapper";
import FlexLeftPanel from "./Components/Shared/PanelElements/FlexLeftPanel";
import FlexRightPanel from "./Components/Shared/PanelElements/FlexRightPanel";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useTheme } from "@mui/material/styles";

import { submissionSocketEventsHandler } from "./Components/CustomerPhoneNumber/Shared/socketEventHelper";

import { Dlog } from "./../../utils/Dlog";

import HttpContext from "../../contexts/HTTP/HttpContext";
import KioskContext from "../../contexts/Kiosk/KioskContext";
import SocketIOContext from "../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useNavigate } from "react-router-dom";

import { checkView } from "./HelperFunctions/viewFunctions";
import HorizontalLayout from "./Components/SubmissionApproval/HorizontalLayout";
import VerticalLayout from "./Components/SubmissionApproval/VerticalLayout";

let env = require("./../../env");

function SubmissionApproval({ authenticate }) {
  const theme = useTheme();
  const { simplepost } = useContext(HttpContext);

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [errorCode, setErrorCode] = useState("");

  //const [kioskkey, setKioskkey] = useState("");
  const [overrideCode, setOverrideCode] = useState("");

  const [loadingTimer, setLoadingTimer] = useState(null);

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const {
    isConnected,
    socketEvents,
    syncTimeOffset,
    connect,
    disconnect,
    getSocket,
    sendEvent,
    clearSocketEvents,
    setQrCode,
    setQrCodeExpireTime,
    setSyncTimeOffset
  } = useContext(SocketIOContext);

  const { getKioskConfiguration, getKioskTheme } = useContext(SocketIOContext);

  //params
  // const { customerName } = route.params;

  const navigate = useNavigate();

  const [orientation, setOrientation] = useState(
    window.screen.orientation.type
  );

  const [workflowmode, setWorkflowmode] = useState(
    getKioskConfiguration()?.workflowMode
  );

  useEffect(() => {
    const handleOrientationChange = () => {
      setOrientation(window.screen.orientation.type);
    };

    window.screen.orientation.addEventListener(
      "change",
      handleOrientationChange
    );

    return () => {
      window.screen.orientation.removeEventListener(
        "change",
        handleOrientationChange
      );
    };
  }, []);

  //Logic for response from Socket.IO
  useEffect(() => {
    console.log("I think an event happened! (AConfiguration)", socketEvents);
    if (socketEvents == null) {
      console.log("socketEvents is null, ignoring");
      return;
    }

    let socketdata = socketEvents.data;
    console.log("socketdata", socketdata);

    let result = socketdata.result;
    let action = socketdata.action;

    if (result == "ERROR") {
      setErrorCode(socketdata.errorcode);
      setLoading(false);
      //stop timer
      if (loadingTimer !== null) {
        clearTimeout(loadingTimer);
        setLoadingTimer(null);
      }
    }

    switch (action) {
      case "RELOGIN":
        reloginViaSocket(getSocket(), "ERRORSCREEN");
        break;
    }

    //Listener for Submission Result Event
    submissionSocketEventsHandler({
      socketEvents: socketEvents,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      customerID: customerID,
      charityName: charityName,
      charityID: charityID,
      numBags: numBags,
      numLabels: numLabels,
      sessionID: sessionID,
      setAllFunc: setAll,
      setLoadingFunc: setLoading,
      setErrorCodeFunc: setErrorCode,
      //setErrorMessageFunc: setErrorMessage,
      successFunc: () => {
        return navigate("/printlabels");
      },
      errorFunc: () => {
        return navigate("/errorscreen");
      },
      clearSocketEventsFunc: clearSocketEvents
    });

    console.log("clearSocketEvents", clearSocketEvents);
    clearSocketEvents();
  }, [socketEvents]);

  //useEffect(() => {}, [socketEvents]);

  const next = async () => {
    console.log("next clicked");
    if (!loading) {
      console.log("overrideCode", overrideCode);
      let subscriptionID = localStorage.getItem("subscriptionID");
      let kioskID = localStorage.getItem("kioskID");

      setLoading(true);
      //KIOSKSUBMISSION
      const payload = {
        type: "KIOSKSUBMISSION",
        payload: {
          subscriptionID: subscriptionID,
          kioskID: kioskID,
          customerName: customerFirstName + " " + customerLastName,
          customerID: customerID,
          numBags: numBags,
          numLabels: numLabels,
          sessionID: sessionID,
          overrideCode: overrideCode
        }
      };

      console.log("SubmissionApproval payload", payload);

      sendEvent(payload, () => {
        console.log("onEventSent");
      });
    }
  };

  const clearError = async () => {
    setErrorCode("");
  };

  const navigatePrinterDebug = async () => {
    navigate("/printerdebug");
  };

  const isNotMobile = useMediaQuery("(min-width:600px)");
  const isLandscape = useMediaQuery("(orientation:landscape)");

  if (checkView(orientation, getKioskTheme()) == "horizontal") {
    return (
      <HorizontalLayout
        overrideCode={overrideCode}
        setOverrideCodeFunc={setOverrideCode}
        nextFunc={next}
        // loading={loading}
        workflowmode={workflowmode}
        getKioskConfiguration={getKioskConfiguration}
        errorCode={errorCode}
        clearErrorFunc={clearError}
      />
    );
  } else {
    return (
      <VerticalLayout
        overrideCode={overrideCode}
        setOverrideCodeFunc={setOverrideCode}
        nextFunc={next}
        // loading={loading}
        workflowmode={workflowmode}
        getKioskConfiguration={getKioskConfiguration}
        errorCode={errorCode}
        clearErrorFunc={clearError}
      />
    );
  }
}

// function mockUniqueID(length) {
//   let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
//   var result = "";
//   for (var i = length; i > 0; --i)
//     result += chars[Math.floor(Math.random() * chars.length)];
//   return result;
// }

export default SubmissionApproval;
